'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'

import { cn } from '@/lib/utils'

interface Props {
    parent: MainNavMenuItem
}

const MainNavDropdown = ({ parent }: Props) => {
    const [isOpen, setisOpen] = useState(false)
    const menuItems = parent.children || []

    const handleToggle = () => {
        setisOpen(!isOpen)
    }

    return (
        <>
            <span
                onClick={handleToggle}
                className="relative no-underline px-2 py-0 lg:py-3 inline-block lg:inline-block text-[#374785] hover:text-[#27325d] dark:text-white dark:hover:text-gray-200 cursor-pointer after:content-[' '] after:block after:w-full after:h-[40px] after:absolute after:left-0 after:bottom:0 after:bg-[url('/images/svg/nav_down_arrow.svg')] after:bg-no-repeat after:bg-center"
                title={parent.title}
            >
                {parent.title}
            </span>
            <div
                className={cn(
                    'absolute left-0 top-[100%] w-full z-10 bg-background border-t border-b border-gray-200 dark:border-gray-800 shadow-md h-auto animate-in fade-in slide-in-from-top duration-300',
                    isOpen ? 'block' : 'hidden'
                )}
            >
                <div className="flex flex-wrap justify-center text-sm font-semibold py-4 gap-10">
                    {menuItems.map((item) => (
                        <div key={item.title}>
                            <Link
                                href={item.href!}
                                title={item.title}
                                className="flex flex-col items-center hover:no-underline"
                            >
                                <div className="pb-3 text-[#374785] dark:text-white">
                                    {item.title}
                                </div>
                                <Image
                                    className="h-12 w-12"
                                    width={48}
                                    height={48}
                                    src={item.imageSrc!}
                                    alt={item.title}
                                />
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default MainNavDropdown
